<template>
<div>
    <table class="table table-striped table-hover table-bordered mt-4">
        <thead class="thead-dark">
            <tr>
                <th></th>
                <th class="titulo text-center" v-for="titulo in tituloSeccion.split('|')" :key="titulo.id" >{{titulo}}</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(data, index) in contenidos" :key="index">
                <th class="text-center texto">{{index+1}}</th>
                <th class="texto" v-for="textoColumna in data.TextoDelContenido.split('|')" :key="textoColumna.index">{{textoColumna}}</th>
                
                <th class="w-10 text-center vinculo texto">
                 <a v-on:click="llenarTablaDeArchivos(data.RutaDeImagen,data.ArchivosDeContenidoMicrositios)"  data-toggle="modal" data-target="#contenidoTabla">{{data.TextoDelVinculo}}</a>
                 <!-- <a v-on:click="llenarTablaDeArchivos(data.RutaDeImagen,data.ArchivosDeContenidoMicrositios)" data-toggle="modal" data-target="">{{data.TextoDelVinculo}} </a> -->
                <!-- <router-link v-if="elemento.AbrirEnVisor==false && elemento.RutaDelArchivo != null && elemento.RutaDelArchivo.includes('Micrositio')" :to="elemento.RutaDelArchivo" >{{elemento.TextoDescripcion}}</router-link>
                <a v-else-if="elemento.AbrirEnVisor==false" v-on:click="AbrirArchivo(elemento.RutaDelArchivo,'_self')">{{elemento.TextoDescripcion}}</a>
                <a v-else-if="elemento.AbrirEnVisor==true" v-on:click="AbreElVisor(elemento.RutaDelArchivo)">{{elemento.TextoDescripcion}}</a> -->
                </th>

            </tr>
        </tbody>
    </table>

<!-- Modal -->
<div class="modal fade bd-example-modal-lg" id="contenidoTabla" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel"></h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        
       <table class="table table-striped table-hover table-bordered mt-4">
            <thead class="thead-dark">
                <tr>
                    <th v-for="(archivo,index) in columnas" :key="index">{{archivo}}</th>
                </tr>
            </thead>
            <tbody>
                 <tr v-for="(dato,index) in datos" :key="index">
                    <th v-for="(fila,index) in dato.TextoDescripcion.split('|')" :key="index">{{fila}}</th>
                    <th>
                      <a v-if="dato.AbrirEnVisor==false" v-on:click="AbrirArchivo(dato.RutaDelArchivo,'_self')"> {{dato.TextoLink}}</a>
                      <a v-else-if="dato.AbrirEnVisor==true" v-on:click="AbreElVisor(dato.RutaDelArchivo)"> {{dato.TextoLink}}</a>
                    </th>
                </tr>
            </tbody>
       </table>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
      </div>
    </div>
  </div>
</div>


</div>    

</template>
<script>
import comun from "@/../static/js/comun";

export default{
    data:function(){
        return{
            columnas:[],
            datos:[],
            RUTA_VISOR: '/Ver/url?file=',
        }
    },
    props:{
        contenidos:Array,
        tituloSeccion: String
    },
    methods:{

        llenarTablaDeArchivos:function(archivos,contenidoTabla){
            this.columnas = archivos.split("|");
            this.datos = contenidoTabla;
        },
       
       AbreElVisor: function(vinculo) {
        alert(vinculo)
         var rutaDescarga=this.$root.$el.baseURI.replace(this.$route.path,this.RUTA_VISOR+vinculo)
         window.open(encodeURI(rutaDescarga),'_blank')
       },
      
      AbrirArchivo: function(vinculo,forma) {
        comun.DescargarDocumentoPDF(vinculo)
      },

    }
}
</script>

<style  scoped>
.titulo{
  font-family: 'AntenaBeta';
  font-size: 16px;
}
#Formato3 .titulo:last-child {
    text-align: center;
  }

  .vinculo a{
color: black;
  font-family: 'Myriad';
  font-size: 1em;

  }
  .texto{
    font-family: 'Myriad';
  font-size: 1.2em;
  }

  .modal-content{
      background-color: white;
  }
  

</style>



// WEBPACK FOOTER //
// src/components/Micrositios/Formatos/ContenidoConTabla.vue